import { Children, type ReactNode } from 'react';
import { renderChildren } from '@fiverr-private/ui_utils';
import type { AttachmentProps } from './Attachment/types';

interface RenderAttachmentsChildrenProps {
    variant: AttachmentProps['variant'];
    theme?: AttachmentProps['theme'];
}

export const renderAttachmentsChildren = (children: ReactNode, { variant, theme }: RenderAttachmentsChildrenProps) =>
    Children.map(Children.toArray(children), (child) =>
        renderChildren(child, {
            variant,
            theme,
        })
    );
